import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    googleLibrary: null,
};

const googleSlice = createSlice({
    name: 'google',
    initialState,
    reducers: {
        googlePlacesInitialized(state, action) {
            const {
                maps: { places },
            } = action.payload;
            state.googleLibrary = {
                // any other services that need to be used should be added here
                // then add exceptions for redux serialization in src/index.js
                AutocompleteSessionToken: places.AutocompleteSessionToken,
                AutocompleteService: places.AutocompleteService,
                PlacesService: places.PlacesService,
            };
        },
    },
});

export const { googlePlacesInitialized } = googleSlice.actions;

export const selectors = {
    getGoogleLibrary: state => state.google.googleLibrary,
};

export default googleSlice.reducer;
